import React from "react";
import { motion } from "framer-motion";
import { Box } from "@chakra-ui/react";

const MotionBox = motion(Box);

const FadeInSection = ({ children, delay = 0, ...rest }) => {
    return (
        <MotionBox
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay }}
            {...rest}
        >
            {children}
        </MotionBox>
    );
};

export default FadeInSection;
